const Quote = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
    >
      <path
        d="M28.0758 32.0272V52.1577H8.09473V46.9386C8.09473 38.7872 8.69106 32.7229 9.88372 28.7466C11.1758 24.6701 14.5065 18.9048 19.8742 11.4482L28.3739 16.2205C23.9007 23.875 21.3158 29.1441 20.62 32.0272H28.0758ZM55.216 32.0272V52.1577H35.2341V46.9386C35.2341 38.7872 35.8304 32.7229 37.0231 28.7466C38.3159 24.6701 41.6459 18.9048 47.0144 11.4482L55.5141 16.2205C51.04 23.875 48.4559 29.1441 47.7594 32.0272H55.216Z"
        fill="#A2CAFF"
      />
    </svg>
  );
};

export default Quote;
